export enum RoutesPage {
  Home = "/",
  Login = "/login",
  LoginConfirm = "/login-confirm",
  Password = "/password",
  SetNewPassword = "/set-new-password",
  ForgotPassword = "/forgot-password",
  UserManagement = "/user-management",
  Dashboard = "/dashboard",
  CreateUser = "/create-user",
  EditUser = "/edit-user",
  ConsentModal = "/consent-modal",
  AddUsers = "/add-users",
  UpdateProfile = "/update-profile",
  TermsOfService = "/terms-of-service",
  PrivacyPolicy = "/privacy-policy",
  AuthCallback = "/auth/callback",
}

export const AuthMethodsMapper = {
  CREDENTIALS: RoutesPage.Password,
  AUTH_CODE: RoutesPage.LoginConfirm,
  OKTA: "okta",
  MIDWAY: "midway",
} as const;
